import type { LucideIcon } from "lucide-react";
import {
  Activity,
  Building2,
  Calendar,
  Car,
  CircleDollarSign,
  ClipboardCheck,
  Clock,
  FilePen,
  FileText,
  HeartPulse,
  Hotel,
  LayoutGrid,
  LineChart,
  MessageCircle,
  Receipt,
  Settings,
  Shield,
  ShoppingCart,
  Ticket,
  TriangleAlert,
  Umbrella,
  Users,
  XCircle,
} from "lucide-react";

export const ADMIN_NAV_ICONS: Record<string, LucideIcon> = {
  "/admin": LayoutGrid,
  "/admin/aujourd-hui": Clock,
  "/admin/bookings": Calendar,
  "/admin/guest-bookings": Users,
  "/admin/vehicles": Car,
  "/admin/vehicle-update-requests": FilePen,
  "/admin/agencies": Building2,
  "/admin/documents": FileText,
  "/admin/kyc": Shield,
  "/admin/users": Users,
  "/admin/invoices": Receipt,
  "/admin/revenue": CircleDollarSign,
  "/admin/withdraws": CircleDollarSign,
  "/admin/promo-codes": Ticket,
  "/admin/cancellations": XCircle,
  "/admin/simulation": LineChart,
  "/admin/no-deposit-simulator": Umbrella,
  "/admin/hotel-partners": Hotel,
  "/admin/operations": Settings,
  "/admin/abandoned-checkouts": ShoppingCart,
  "/admin/chargebacks": TriangleAlert,
  "/admin/damage-claims": TriangleAlert,
  "/admin/reminders": MessageCircle,
  "/admin/health": HeartPulse,
  "/admin/platform-health": Activity,
};

export const adminNavIcon = (path: string): LucideIcon => ADMIN_NAV_ICONS[path] ?? ClipboardCheck;
